module.exports = __webpack_public_path__ + "static/media/MemberLoads.d5477ce3.svg";